import Heron1 from '../Heron/Heron.webp'
import Heron2 from '../Heron/Heron  (2).webp'
import Heron3 from '../Heron/Heron  (3).webp'
import Heron4 from '../Heron/Heron  (4).webp'
import Heron5 from '../Heron/Heron  (5).webp'
import Heron6 from '../Heron/Heron  (6).webp'
import Heron7 from '../Heron/Heron  (7).webp'
import Heron8 from '../Heron/Heron  (8).webp'
import Heron9 from '../Heron/Heron  (9).webp'
import Heron10 from '../Heron/Heron  (10).webp'
import Heron11 from '../Heron/Heron  (11).webp'
import Heron12 from '../Heron/Heron  (12).webp'
import Heron13 from '../Heron/Heron  (13).webp'
import Heron14 from '../Heron/Heron  (14).webp'
import Heron15 from '../Heron/Heron  (15).webp'
import Heron16 from '../Heron/Heron  (16).webp'
import Heron17 from '../Heron/Heron  (17).webp'


const Heronimages =[
Heron1,Heron2,Heron3,Heron4,Heron5,Heron6,Heron7,Heron8,Heron9,Heron10,Heron11,Heron12,Heron13,Heron14,Heron15,Heron16,Heron17
]

export default Heronimages;